import {
  verifyHyCoupon
} from "./chunk-75FO4HW4.mjs";

// src/hooks/hy/coupon/verify.ts
import { useMutation } from "@tanstack/react-query";
var useVerifyHyCoupon = () => {
  return useMutation({
    mutationFn: verifyHyCoupon
  });
};

export {
  useVerifyHyCoupon
};
//# sourceMappingURL=chunk-3TQB3RXV.mjs.map